// @flow

import React, { Component } from 'react';
import Alert from 'react-s-alert';
import FlatButton from 'material-ui/FlatButton';
import Toggle from 'material-ui/Toggle';
import Range from 'rc-slider/lib/Range';
import {Icon} from 'react-fa';
import 'rc-slider/assets/index.css';
import _ from 'lodash';

import Wait from './Wait.jsx';
import LeftRight from './LeftRight.jsx';
import App from './App.jsx';
import {get_stats_limits} from './show_stats.js';
import {get_tif_friend_of, get_mav_areas, get_mapatematico_minmax} from './fetch_things.js';
import {get_label, takeDir, takeFilename, takeBasename, gen_snum, inv, no_rclick, fecha, isNumber, fix_range_diff} from './utils.js';

import type {T_ErrOk, T_NextErrOk, T_ErrAreasZonas} from './types.js';

import './css/DialogMav.css';

const Rainbow = require('rainbowvis.js');

const S = require("underscore.string");


export type T_DialogMavProps = {
  culti       : string,
  elem        : string,
  left        : number,
  num_decimals: number,
  app         : App
};


export type T_DialogMavState = {
  num_ranges   : number,
  elem_name    : string,
  val_min      : number,
  val_max      : number,
  vdosis       : Array<number>,
  asc          : boolean,
  waiting      : boolean,
  slider_values: Array<number>,
  need_reclass : boolean,
  dosis_changed: boolean,
  mav_failed   : boolean,
  proj         : string,
  slider_smooth: boolean,
  last_mav_done: string
};


const INIT_STATE: T_DialogMavState = {
  num_ranges   : 3,
  elem_name    : '',
  val_min      : 0,
  val_max      : 1000,
  vdosis       : [300, 200, 100],
  asc          : false,
  waiting      : false,
  slider_values: [333.33, 666.666],
  need_reclass : true,
  dosis_changed: false,
  mav_failed   : false,
  proj         : 'UTM',
  slider_smooth: false,
  last_mav_done: ''
};



export default class DialogMav extends Component<T_DialogMavProps, T_DialogMavState> {
  rainbows: Array<Object>;
  
  make_mav          : () => void;
  change_num_ranges : (ev: SyntheticInputEvent<*>) => void;
  change_order_dosis: (ev: Event, asc: boolean) => void;
  change_range      : (slider_values: Array<number>) => void;
  change_dosis      : (ev: SyntheticInputEvent<*>) => void;
  proj_utm          : () => void;
  proj_ll           : () => void;
  
  
  
  constructor(props: T_DialogMavProps) {
    super(props);
    
    this.state = _.cloneDeep(INIT_STATE);
    
    const colors  = ['#dc143c', '#ffd700', '#008000'];
    
    this.rainbows = _.range(2, 6).map((num) => {
      const ra = new Rainbow(),
            rd = new Rainbow();
      
      ra.setSpectrum(...inv(colors));
      rd.setSpectrum(...colors);
      ra.setNumberRange(1, num);
      rd.setNumberRange(1, num);
      
      return {ra, rd};
    });
    
    this.make_mav           = this.make_mav.bind(this);
    this.change_num_ranges  = this.change_num_ranges.bind(this);
    this.change_order_dosis = this.change_order_dosis.bind(this);
    this.change_dosis       = this.change_dosis.bind(this);
    this.change_range       = this.change_range.bind(this);
    this.proj_utm           = this.proj_utm.bind(this);
    this.proj_ll            = this.proj_ll.bind(this);
    
    this.props.app.dialog_mav = this;
  }
  
  
  
  close(): void {
    this.props.app.map_ui.setState({show_mav: false});
  }
  
  
  
  load(): void {
    const {app, culti} = this.props,
          png = takeFilename(this.props.elem),
          dir = takeDir(culti);
    
    if (png.indexOf('Mapa_Tematico_') === 0) {
      const png_base = takeBasename(png),
            tif_path = `${dir}/${png_base}.tif`;
      
      get_mapatematico_minmax(app, tif_path, (vs) => {
        if (vs[0] === 0 && vs[1] === 0) {
          Alert.error('No pude obtener los extremos del mapa temático.');
          this.close();
        }
        else {
          this.setState({
            val_min  : vs[0],
            val_max  : vs[1],
            elem_name: png_base.slice(14)
          });
        }
      });
    }
    else {
      get_stats_limits(app, culti, () => {
        if (_.has(app.map_ui.Lim_List, dir) && _.has(app.map_ui.Lim_List[dir], png)) {
          const [val_min, val_max] = app.map_ui.Lim_List[dir][png];
          
          this.setState({
            val_min,
            val_max,
            elem_name: get_label(this.props.elem)
          });
        }
        else {
          Alert.error('Este elemento no tiene estadísticas');
          this.close();
        }
      });
    }
  }
  
  
  
  componentDidUpdate(prevProps: T_DialogMavProps, prevState: T_DialogMavState) {
    if (this.props.elem !== prevProps.elem) {
      this.setState({need_reclass: true});
    }
  }
  
  
  
  componentDidMount() {
    this.load();
  }
  
  
  
  componentWillUnmount() {
    this.props.app.dialog_mav = null;
  }
  
  
  
  reclass_if(need: boolean, tif_in: string, tif_out: string, ranges_: Array<number>, next: T_NextErrOk): void {
    if (need) {
      const {app}    = this.props,
            ses      = app.session(),
            is_nitro = this.state.elem_name.toLowerCase().indexOf('nitrosense') !== -1,
            ranges   = is_nitro ? ranges_.map(num => num + 1000) : ranges_,
            is_diff  = _.startsWith(takeFilename(tif_in), 'diff_'),
            url      = `${app.remote}/reclass-tif/?session_id=${ses}&tif_in=${tif_in}&tif_out=${tif_out}&ranges=${ranges.map(fix_range_diff(is_diff)).join(',')}`;
      
      fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
        next(response);
      });
    }
    else {
      next({ok: 'no need'});
    }
  }
  
  
  
  polygonize(tif: string, mask: string, out: string, next: T_NextErrOk): void {
    const {app} = this.props,
          url   = `${app.remote}/polygonize-raster/?session_id=${app.session()}&tif=${tif}&mask=${mask}&out=${out}`;
    
    fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
      next(response);
    });
  }
  
  
  
  smooth_shp(shp_in: string, shp_out: string, simplify: number, next: T_NextErrOk): void {
    const {app} = this.props,
          url   = `${app.remote}/smooth-shp/?session_id=${app.session()}&shp_in=${shp_in}&shp_out=${shp_out}&simplify=${simplify}`;
    
    fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
      next(response);
    });
  }
  
  
  
  build_mav_dbf(mav_path: string, vdosis: Array<number>, colors: Array<string>, areas: Array<number>, next: T_NextErrOk): void {
    const {app}  = this.props,
          params = `vdosis=${vdosis.join(',')}&colors=${colors.join(',')}&areas=${areas.join(',')}`,
          url    = `${app.remote}/build-mav-dbf/?session_id=${app.session()}&mav=${mav_path}&${params}`;
    
    fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
      next(response);
    });
  }
  
  
  
  reproj_if(mav_path: string, mav_out: string, next: T_NextErrOk): void {
    if (this.state.proj === 'UTM') {
      next({ok: 'no need'});
    }
    else {
      const {app} = this.props,
            url   = `${app.remote}/shp-utm-to-latlong/?session_id=${app.session()}&path_in=${mav_path}&path_out=${mav_out}`;
      
      fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
        next(response);
      });
    }
  }
  
  
  
  remove_if(need: boolean, dir: string, pattern: string, next: T_NextErrOk): void {
    if (need) {
      const {app} = this.props,
            url   = `${app.remote}/remove-files/?session_id=${app.session()}&dir=${dir}&pattern=${pattern}`;
      
      fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
        next(response);
      });
    }
    else {
      next({ok: 'no need'});
    }
  }
  
  
  
  bad_ending(msg: string): void {
    this.setState({waiting: false, mav_failed: true}, () => {
      Alert.error(msg);
    });
  }
  
  
  
  good_ending(): void {
    this.setState({waiting: false});
  }
  
  
  
  make_mav(): void {
    const ranges = this.get_ranges();
    
    if (ranges.length !== _.uniq(ranges).length) {
      return Alert.error('Los rangos de aplicación están mal definidos');
    }
    
    const {app}      = this.props,
        png_path     = this.props.elem,
        dir          = takeDir(png_path),
        need_reclass = _.cloneDeep(this.state.need_reclass);
    
    this.setState({need_reclass: false, dosis_changed: false, waiting: true, mav_failed: false}, () => {
      get_tif_friend_of(app, png_path, (trio) => {
        if (trio != null) {
          const es_mtem     = trio.tif.indexOf('Mapa_Tematico_') === 0,
                tif_path    = `${dir}/${es_mtem ? '_raw_' : ''}${trio.tif}`,
                tif_reclass = `${dir}/_reclass_${trio.tif}`,
                base_mav    = `mav_${trio.elem}_${fecha()}-UTM.shp`,
                mav_raw     = `${dir}/_raw_${base_mav}`,
                mid_ranges  = _.initial(_.tail(ranges)),
                colors      = this.get_colors();
          
          let mav_output = `${dir}/${base_mav}`;
          
          this.reclass_if(need_reclass, tif_path, tif_reclass, mid_ranges, (res_reclass: T_ErrOk) => {
            // console.log(res_reclass);
            
            if (res_reclass.error && typeof res_reclass.error === 'string') {
              this.bad_ending(res_reclass.error);
            }
            else {
              this.polygonize(tif_reclass, tif_reclass, mav_raw, (res_polygonize: T_ErrOk) => {    // 2nd was tif_path
                // console.log(res_polygonize);
                
                if (res_polygonize.error && typeof res_polygonize.error === 'string') {
                  this.bad_ending(res_polygonize.error);
                }
                else {
                  this.smooth_shp(mav_raw, mav_output, 0.2, (res_smooth: T_ErrOk) => {
                    // console.log(res_smooth);
                    
                    if (res_smooth.error && typeof res_smooth.error === 'string') {
                      this.bad_ending(res_smooth.error);
                    }
                    else {
                      get_mav_areas(app, mav_output, (res_areas: T_ErrAreasZonas) => {
                        // console.log(res_areas);
                        
                        if (res_areas.error && typeof res_areas.error === 'string') {
                          this.bad_ending(res_areas.error);
                        }
                        else if (res_areas.areas instanceof Array && res_areas.zonas instanceof Array) {
                          const areas = res_areas.areas,                      // eslint-disable-line prefer-destructuring
                                zonas = res_areas.zonas;                      // eslint-disable-line prefer-destructuring
                          
                          this.build_mav_dbf(mav_output, this.state.vdosis, colors.map(color => color.slice(1)), areas, (res_dosis: T_ErrOk) => {
                            // console.log(res_dosis);
                            
                            if (res_dosis.error && typeof res_dosis.error === 'string') {
                              this.bad_ending(res_dosis.error);
                            }
                            else {
                              const mav_detail = {
                                ranges,
                                colors,
                                vdosis: this.state.vdosis,
                                areas,
                                zonas,
                                createdBy: app.state.user.user_name
                              };
                              
                              app.post_json(mav_detail, `${mav_output}.json`, (res_post) => {
                                // console.log('post_json', res_post);
                                
                                if (res_post.error && typeof res_post.error === 'string') {
                                  this.bad_ending(res_post.error);
                                }
                                else {
                                  const mav_ll = mav_output.replace('-UTM.shp', '-LL.shp');
                                  
                                  this.reproj_if(mav_output, mav_ll, (res_reproj: T_ErrOk) => {
                                    // console.log('reproj_if', res_reproj);
                                    
                                    if (res_reproj.error && typeof res_reproj.error === 'string') {
                                      this.bad_ending(res_reproj.error);
                                    }
                                    else {
                                      if (this.state.proj === 'LL') {
                                        mav_output = mav_ll;
                                      }
                                      
                                      const need_rm = (this.get_proj_of(this.state.last_mav_done) === 'LL' &&
                                                       this.state.proj === 'UTM'),
                                            pattern = `*${takeBasename(takeFilename(this.state.last_mav_done))}.*`;
                                      
                                      this.remove_if(need_rm, dir, pattern, (res_remove: T_ErrOk) => {
                                        // console.log('remove_if', res_remove);
                                        
                                        if (res_remove.error && typeof res_remove.error === 'string') {
                                          this.bad_ending(res_remove.error);
                                        }
                                        else {
                                          const zombie_props = _.cloneDeep(_.omit(this.props, ['app'])),
                                                zombie_state = _.cloneDeep(this.state);
                                          
                                          this.setState({waiting: false});
                                          
                                          app.log_user_action('crear_mav', mav_output);
                                          
                                          app.kill_these(app.map_ui.map.things_loaded().filter(xp => takeDir(xp) === dir), () => {
                                            // NOTE: A PARTIR DE AQUÍ, DialogMav ESTÁ MUERTO. NO INVOQUES A LOS MUERTOS.
                                            
                                            _.delay(() => {
                                              app.reload_dir(dir, (res) => {
                                                _.delay(() => {
                                                  const item_mav = app.get_item_shp(mav_output);
                                                  
                                                  if (item_mav) {
                                                    const item = item_mav;
                                                    
                                                    item.open(() => {
                                                      zombie_state.waiting       = false;
                                                      zombie_state.slider_smooth = true;
                                                      zombie_state.last_mav_done = mav_output;
                                                      zombie_props.app           = app;
                                                      
                                                      app.map_ui.setState({zombie_mav: {zombie_props, zombie_state}}, () => {
                                                        app.setState({showing_mav: true});
                                                      });
                                                      
                                                      app.sidebar.setState({bt_active: 'Mapas'}, () => {
                                                        app.sidebar.show_tree();
                                                        
                                                        item.scroll();
                                                      });
                                                    });
                                                  }
                                                  else {
                                                    Alert.error('No se pudo construir el mapa.');
                                                  }
                                                }, 150);
                                              });
                                            }, 150);
                                          });
                                        }
                                      });
                                    }
                                  });
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
        else {
          this.bad_ending(`No encuentro el raster asociado a ${takeFilename(png_path)}.`);
        }
      });
    });
  }
  
  
  
  change_num_ranges(ev: SyntheticInputEvent<*>): void {
    const num_ranges = parseInt(ev.target.value, 10),
          ds = _.range(100 * num_ranges, 0, -100);
    
    this.setState({
      num_ranges,
      vdosis: this.state.asc ? inv(ds) : ds,
      slider_values: _.range(1, num_ranges).map(num => num * 1000 / num_ranges),
      need_reclass: true
    });
  }
  
  
  
  change_order_dosis(ev: Event, asc: boolean): void {
    const ds = _.range(100 * this.state.num_ranges, 0, -100);
    
    this.setState({
      asc,
      vdosis: this.state.asc ? ds : inv(ds),
      dosis_changed: true
    });
  }
  
  
  
  change_dosis(ev: SyntheticInputEvent<*>): void {
    console.log('change_dosis', ev.target.value, ev.target.dataset.num);
    
    // $FlowFixMe:
    const val       = _.map(ev.target.value, ch => ch.charCodeAt(0)).filter(ch => 46 <= ch && ch <= 58).map(num => String.fromCharCode(num)).join(''),
          num       = parseInt(ev.target.dataset.num, 10),
          new_dosis = isNumber(val) ? parseFloat(val) : 0;
    
    if (this.state.vdosis[num] === new_dosis) {
      return;
    }
    
    const ds = _.cloneDeep(this.state.vdosis);
    
    ds[num] = new_dosis;
    
    this.setState({
      vdosis: ds,
      dosis_changed: true
    });
  }
  
  
  
  change_range(slider_values: Array<number>): void {
    this.setState({slider_values, need_reclass: true});
  }
  
  
  
  get_ranges(): Array<number> {
    const len = this.state.val_max - this.state.val_min;
    
    return [this.state.val_min, ...this.state.slider_values.map(val => this.state.val_min + (len * (val / 1000))), this.state.val_max];
  }
  
  
  
  get_colors(): Array<string> {
    return _.range(this.state.num_ranges).map((num) => {
      return `#${this.rainbows[this.state.num_ranges - 2][this.state.asc ? 'ra' : 'rd'].colourAt(num + 1)}`;
    });
  }
  
  
  
  proj_utm(): void {
    if (this.state.proj !== 'UTM') {
      this.setState({proj: 'UTM'});
    }
  }
  
  
  
  proj_ll(): void {
    if (this.state.proj !== 'LL') {
      this.setState({proj: 'LL'});
    }
  }
  
  
  
  get_proj_of(mav_path: string): string {
    if (S.endsWith(mav_path, '-UTM.shp')) {
      return 'UTM';
    }
    else if (S.endsWith(mav_path, '-LL.shp')) {
      return 'LL';
    }
    else {
      return '';
    }
  }
  
  
  
  need_reproj(): boolean {
    if (this.state.last_mav_done === '') {
      return this.state.proj === 'LL';
    }
    else {
      return this.get_proj_of(this.state.last_mav_done) !== this.state.proj;
    }
  }
  
  
  
  render() {
    const ranges = this.get_ranges(),
          colors = this.get_colors(),
          style  = {height: 495 + (35 * (this.state.num_ranges - 3))},
          snum   = gen_snum(this.props.num_decimals);
    
    return (
        <div className='dialog_mav' style={style} onContextMenu={no_rclick}>
          <h4 className='Center'>
            Aplicación variable de {this.state.elem_name}
          </h4>
          
          <div className='mav_num_ranges'>
            Número de rangos:
            <input type='number' min={2} max={5} value={this.state.num_ranges} onChange={this.change_num_ranges} />
          </div>
          
          <div className='mav_slider'>
            <Range min={0} max={1000} value={this.state.slider_values} onChange={this.change_range} />
            
            <LeftRight
              left={<span>{snum(this.state.val_min)}</span>}
              right={<span>{snum(this.state.val_max)}</span>}
            />
          </div>
          
          <Toggle label='Dosis crecientes:' toggled={this.state.asc} style={{width: '50%', marginLeft: 40}}
            onToggle={this.change_order_dosis}
          />
          
          <div className='Center'>
            <table className='table_mav'>
              <thead>
                <tr>
                  <td>desde</td>
                  <td>hasta</td>
                  <td>dosis (kg/ha)</td>
                  <td>color</td>
                </tr>
              </thead>
              <tbody>
                {_.range(this.state.num_ranges).map((num) => {
                  return (
                    <tr key={num}>
                      <td>{snum(ranges[num    ])}</td>
                      <td>{snum(ranges[num + 1])}</td>
                      <td>
                        <input type='text' value={this.state.vdosis[num]} size={5} data-num={num} onChange={this.change_dosis} />
                      </td>
                      <td className='esc_color'>
                        <div className='Center' style={{backgroundColor: colors[num]}}>
                          &nbsp;
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          
          <div className='mav_proj'>
            <p>Proyección:</p>
            
            <div onClick={this.proj_utm}>
              <Icon name={this.state.proj === 'UTM' ? 'check-circle' : 'circle-o'} /> UTM
            </div>
            
            <div onClick={this.proj_ll}>
              <Icon name={this.state.proj === 'LL'  ? 'check-circle' : 'circle-o'} /> Latitud / Longitud
            </div>
          </div>
          
          <div className='Center'>
            {this.state.waiting ?
              <Wait small={true} />
            :
              <FlatButton
                label='Generar Mav'
                primary={true}
                disabled={
                  ! (this.state.need_reclass || this.state.dosis_changed || this.state.mav_failed || this.need_reproj())
                }
                onClick={this.make_mav}
              />
            }
          </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/DialogMav.jsx